var map = {
    "en-us": "en-us",
    "es-es": "es-es",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw"
};
var i18n = {
    "en-us": {
        'confirm': 'Ok',
        'cancel': 'Cancel',
        'yes': 'Yes',
        'no': 'No'
    },
    "es-es": {
        'confirm': 'Ok',
        'cancel': 'Cancel',
        'yes': 'Sí',
        'no': 'No'
    },
    "zh-cn": {
        'confirm': '确认',
        'cancel': '取消',
        'yes': '是',
        'no': '否'
    },
    "zh-tw": {
        'confirm': '確認',
        'cancel': '取消',
        'yes': '是',
        'no': '否'
    }
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}
var locale;
try {
    locale = seajs.data.vars.locale;
} catch (e) {
    locale = 'en-us';
}

module.exports = _(locale);
